function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach(
      (button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.dotsDiv = this.querySelector(".pi-slider-dots");
    this.labelAsCarousel();

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  // ADA: a carousel is announced as one, with a name (accessFlow, "Carousels
  // should be tagged and labeled properly"). Every slider-component on the site
  // passes through here, so the sections need no markup of their own. The name is
  // the matching tab label inside a tab panel, else the section's heading.
  labelAsCarousel() {
    // The prev/next buttons are rendered with aria-controls="Slider-<section id>",
    // which is not this slider's id wherever a slider is nested in another
    // section (product recommendations, quick-add). Point them at the real list,
    // or drop the reference rather than name an id that does not exist.
    const list = this.querySelector('[id^="Slider-"]');
    this.querySelectorAll("button[aria-controls]").forEach((button) => {
      if (document.getElementById(button.getAttribute("aria-controls"))) return;
      if (list) button.setAttribute("aria-controls", list.id);
      else button.removeAttribute("aria-controls");
    });
    if (this.hasAttribute("role")) return;
    let label = this.getAttribute("aria-label");
    const panel = this.closest(".pi-tab-panel");
    const host = panel && panel.closest("pi-tab-panel");
    if (!label && host) {
      const i = Array.from(host.querySelectorAll(".pi-tab-panel")).indexOf(panel);
      const tab = host.querySelectorAll(".pi-tab-label")[i];
      label = tab && tab.textContent;
    }
    if (!label) {
      const section = this.closest(".shopify-section");
      const heading = section && section.querySelector("h1, h2, h3");
      label = heading && heading.textContent;
    }
    this.setAttribute("role", "region");
    this.setAttribute("aria-roledescription", "carousel");
    this.setAttribute("aria-label", (label || "").replace(/\s+/g, " ").trim().slice(0, 80) || "Carousel");
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.renderDots();
    this.update();
  }

  renderDots() {
    var html = "";
    for (var i = 1; i <= this.totalPages; i++) {
      html += '<span class="pi-slider-dot" data-index="' + i + '"></span>';
    }
    if (this.dotsDiv) {
      this.dotsDiv.innerHTML = html;
    }
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    if ((this.dotsDiv) && (this.currentPage)) {
      this.dotsDiv.querySelectorAll(".pi-slider-dot").forEach((dot) => {
        dot.classList.remove("active");
      });
      this.dotsDiv
        .querySelector(`[data-index="${this.currentPage}"]`)
        .classList.add("active");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class VerticalSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.dotsDiv = this.querySelector(".pi-slider-dots");

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;
    this.slidesPerPage = Math.floor(
      (this.slider.clientHeight - this.sliderItemsToShow[0].offsetTop) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.renderDots();
    this.update();
  }

  renderDots() {
    var html = "";
    for (var i = 1; i <= this.totalPages; i++) {
      html += '<span class="pi-slider-dot" data-index="' + i + '"></span>';
    }
    if (this.dotsDiv) {
      this.dotsDiv.innerHTML = html;
    }
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    if (this.dotsDiv) {
      this.dotsDiv.querySelectorAll(".pi-slider-dot").forEach((dot) => {
        dot.classList.remove("active");
      });
      this.dotsDiv
        .querySelector(`[data-index="${this.currentPage}"]`)
        .classList.add("active");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientHeight + this.slider.scrollTop - offset;
    return (
      element.offsetTop + element.clientHeight <= lastVisibleSlide &&
      element.offsetTop >= this.slider.scrollTop
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollTop + step * this.sliderItemOffset
        : this.slider.scrollTop - step * this.sliderItemOffset;
    this.slider.scrollTo({
      top: this.slideScrollPosition,
    });
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("vertical-slider-component", VerticalSliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
   
    this.addEventListener("change", this.onVariantChange.bind(this));
    this.onAddButtonClick = this.onAddButtonClick.bind(this);
  }
  connectedCallback() {
    // initSelect2 depends on jQuery + select2, both of which load from external CDNs. If
    // either is slow or blocked, `$` is undefined and this used to throw — taking
    // deselectVariantOnLoad() with it and leaving the page with no usable buy block until
    // a reload. Enhancement failures must never block the buy path.
    try {
      this.initSelect2();
    } catch (e) {
      console.warn('variant-selects: select2 init failed, continuing without it', e);
      this.bindAddButton();
    }
    try {
      this.enableVariantDeselect();
    } catch (e) {
      console.warn('variant-selects: deselect handler failed', e);
    }
    try {
      this.deselectVariantOnLoad();
    } catch (e) {
      console.warn('variant-selects: initial variant setup failed', e);
    }
    // Whatever happened above, the buy block must end up visible.
    const block = document.querySelector('.pi-product-content-block');
    if (block) block.classList.remove('initialhide', 'hide');
  }
  bindAddButton() {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    // Guard must live on the <button> itself, not the inner label span, or clicks
    // landing on the icon / price / padding bypass it and submit an empty variant id.
    this.addButton = productForm.querySelector('[name="add"]');
    this.addButtonLabel = productForm.querySelector('[name="add"] .product_button_lable');
    if (!this.addButton) return;
    this.addButton.removeEventListener('click', this.onAddButtonClick);
    this.addButton.addEventListener('click', this.onAddButtonClick);
  }
  initSelect2() {
    const hasSelect2 = typeof window.jQuery === 'function' && typeof window.jQuery.fn.select2 === 'function';
    this.querySelectorAll('.select2').forEach((select) => {
      if (!hasSelect2) {
        // Fall back to the native <select>, which still fires `change`.
        select.addEventListener('change', () => this.onVariantChange());
        return;
      }
      $(select).select2().on('change', () => {
        this.onVariantChange();
      });
    });
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    // Guard must live on the <button> itself, not the inner label span, or clicks
    // landing on the icon / price / padding bypass it and submit an empty variant id.
    this.addButton = productForm.querySelector('[name="add"]');
    this.addButtonLabel = productForm.querySelector('[name="add"] .product_button_lable');

    if (!this.addButton) return;
    this.addButton.addEventListener('click', this.onAddButtonClick);
  }
  onAddButtonClick(e) {
    if (!this.currentVariant) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (this.addButtonLabel) this.addButtonLabel.textContent = 'Choose an option';
    }
  }
  onVariantChange() {
    const contentBlock = document.querySelector('.pi-product-content-block');

    // The block used to be collapsed here — classList.add('hide') — to play a close/open
    // animation on every variant change. .hide sets max-height: 0 with a 0.35s transition, so
    // the whole buy area concertina'd shut and back open: the page jumped up, then dropped
    // down again, on every single tap of a variant pill. Shoppers reported exactly that, and
    // it is worst on mobile where the buy area is most of the screen.
    //
    // Nothing depended on the collapse. It was decoration, and it also caused the two false
    // "content block collapsed" alarms from the buy-button watch, since a block sitting at
    // max-height: 0 is indistinguishable from a genuinely broken one while the timer runs.
    //
    // .initialhide is a different thing and is left alone: it hides the block on first paint
    // until JS resolves the variant, and is cleared below.
    if (contentBlock) {
      contentBlock.classList.remove('hide');
      clearTimeout(this.contentBlockFailsafe);
    }

    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    // Everything below is auxiliary UI: pickup availability, option availability states,
    // variant descriptions. A throw in any of them used to abort onVariantChange before the
    // button state was resolved, leaving Add to Bag disabled with a stale label. Nothing
    // here is allowed to stop the shopper being able to buy.
    ["updatePickupAvailability", "removeErrorMessage", "updateVariantStatuses", "toggleVariantDescription"]
      .forEach((step) => {
        try {
          this[step]();
        } catch (e) {
          console.warn("variant-selects: " + step + " failed, continuing", e);
        }
      });
    if (!this.currentVariant) {
      // Must be `true` so the button is genuinely disabled. With `false`,
      // toggleAddButton strips the disabled attribute and overwrites the label
      // with "Add to cart" — leaving a live button wired to an empty variant id.
      this.toggleAddButton(true, "Choose an option", true);
      this.setUnavailable();
      // renderProductInfo() is what normally restores the label opacity, and it is not
      // called on this branch — so restore it here or the button reads as blank.
      this.toggeleTextOpacity("1");
      if (this.addButton) this.addButton.addEventListener('click', this.onAddButtonClick);
    } else {
      if (this.addButton) this.addButton.removeEventListener('click', this.onAddButtonClick);
      // The variant input and the button state come FIRST. updateMedia() previously ran
      // ahead of them and could throw (media-gallery not yet upgraded), which left the
      // button stuck disabled from the toggleAddButton(true, ...) call above.
      this.updateVariantInput();
      // Resolve the button from the variant data we already hold, synchronously.
      // toggleAddButton(true, ...) above disabled it and hid the label; previously the only
      // thing that undid that was renderProductInfo()'s .then(), so the shopper could not
      // buy until a network round-trip to Shopify finished — and never, if it failed.
      // The section fetch below still refines price/inventory markup, but it no longer
      // gates whether the product is purchasable.
      const strings = window.variantStrings || {};
      this.toggleAddButton(
        !this.currentVariant.available,
        this.currentVariant.available ? "" : strings.soldOut,
        true
      );
      this.toggeleTextOpacity("1");
      this.updateButtonPrice();
      // Everything below is presentation. None of it may prevent the shopper buying.
      ["updateMedia", "updateURL", "renderProductInfo", "updateShareUrl", "updateWishlistVariant"]
        .forEach((step) => {
          try {
            this[step]();
          } catch (e) {
            console.warn("variant-selects: " + step + " failed, continuing", e);
          }
        });
    }
    const variantChangeEvent = new Event("variant:change");
    document.dispatchEvent(variantChangeEvent);

    // Was a 500ms delay to let the open animation finish. With no collapse there is nothing
    // to wait for, and waiting only kept the block hidden on first load for half a second
    // longer than necessary.
    if (contentBlock) {
      contentBlock.classList.remove('hide', 'initialhide');
    }

  }
  // The wishlist button's data-variant-id is baked in at render time. Without this, adding
  // to the wishlist always saves whichever variant happened to render first, regardless of
  // what the shopper actually selected.
  // Render the in-button price from the variant data already in the page.
  // Previously this only ever changed inside renderProductInfo()'s .then(), i.e. after a
  // network round-trip — so switching variants quickly, or a slow/failed fetch, left the
  // shopper looking at the previous variant's price.
  updateButtonPrice() {
    const target = document.getElementById(`ButtonPrice-${this.dataset.section}`);
    if (!target || !this.currentVariant) return;
    const format = target.dataset.moneyformat;
    const money = (cents) => {
      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        return window.Shopify.formatMoney(cents, format);
      }
      return "$" + (cents / 100).toFixed(2);
    };
    const price = this.currentVariant.price;
    const compare = this.currentVariant.compare_at_price;
    let html = "";
    if (compare && compare > price) {
      html += `<s class="price-item price-item--regular">${money(compare)}</s>`;
    }
    html += `<span class="price-item price-item--sale price-item--last">${money(price)}</span>`;
    target.innerHTML = html;
  }

  updateWishlistVariant() {
    if (!this.currentVariant) return;
    document
      .querySelectorAll('.product_addtowishlist [data-swaction="addToWishlist"]')
      .forEach((button) => {
        button.setAttribute('data-variant-id', this.currentVariant.id);
      });
  }

  toggleVariantDescription() {

    

    /*const descriptions = document.querySelectorAll(".variant__description_wrapper .variant__description");
    descriptions.forEach(desc => {
      desc.classList.add("hidden");
    });
    const currentDesc = document.querySelector(".variant__description_wrapper #variant_description_" + this.currentVariant.id);
    if (currentDesc) {
      currentDesc.classList.remove("hidden");
    }
    document.getElementById('complimentary-box-container').querySelector('#include_box').checked = false;
    if (this.currentVariant.sku.indexOf('-COMBO') > -1) {
      document.getElementById('complimentary-box-container').style['display'] = 'flex';
      document.getElementById('complimentary-box-container').classList.add('active');
    } else {
      document.getElementById('complimentary-box-container').style['display'] = 'none';
      document.getElementById('complimentary-box-container').classList.remove('active');
    }
  */
    


     const descriptions = document.querySelectorAll(".variant__description_wrapper .variant__description");

      const priceBox = document.querySelector('.price--on-sale');
      const proWrapper = document.querySelector('.product-form__buttons');

      if (priceBox && proWrapper) {
        proWrapper.classList.add('has-sale-price');
      }
      

      // 1) Close all descriptions (they will animate to closed state)
      descriptions.forEach(desc => {
        desc.classList.add("hidden");
      });

      // 3) Complimentary box logic. The box of this picker's own product form: a quick-add pop-up
      // puts a second product form on the page (see snippets/pi-complimentary-box.liquid).
      const box = document.getElementById(`complimentary-box-container-${this.dataset.section}`);
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      const boxProperty = productForm ? productForm.querySelector('#include_box_form') : null;

      // Reset on every variant change. The property must be cleared alongside the checkbox,
      // not only on the non-COMBO branch below — otherwise switching from one COMBO variant
      // to another left the box visually unticked while still submitting the old value.
      if (box) {
        const includeBoxCheckbox = box.querySelector('input[type="checkbox"]');
        if (includeBoxCheckbox) includeBoxCheckbox.checked = false;
      }
      if (boxProperty) boxProperty.value = '';

      // No matching variant (an unavailable option combination). Everything stays
      // closed. Dereferencing this.currentVariant past this point would throw and
      // abort onVariantChange, leaving .pi-product-content-block stuck collapsed.
      if (!this.currentVariant) {
        this.setComplimentaryBox(box, false);
        if (boxProperty) boxProperty.value = '';
        return;
      }

      // 2) Open the current variant's description
      const currentDesc = document.querySelector(
        ".variant__description_wrapper #variant_description_" + this.currentVariant.id
      );
      if (currentDesc) {
        currentDesc.classList.remove("hidden");
      }

      if (box && this.qualifiesForComplimentaryBox(this.currentVariant, box)) {
        this.setComplimentaryBox(box, true);
      } else {
        this.setComplimentaryBox(box, false);
        if (boxProperty) boxProperty.value = '';
      }
  }
  updateOptions() {
    // Native .value rather than $(select).val() — this runs on every variant change, and
    // jQuery loading from a CDN must not be a prerequisite for reading a <select>.
    this.options = Array.from(this.querySelectorAll(".select2"), (select) => select.value);
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  // Return the gallery to the product's first media. Used when a variant carries no image
  // of its own, and when the shopper clears their variant selection.
  resetMediaToFirst() {
    document
      .querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`)
      .forEach((gallery) => {
        if (typeof gallery.setActiveMedia !== "function") return;
        const first = gallery.querySelector("[data-media-id]");
        if (first) gallery.setActiveMedia(first.dataset.mediaId, false);
      });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    // A variant with no image of its own should not leave the previous variant's photo in
    // the hero slot — fall back to the product's lead shot (the colour swatch).
    if (!this.currentVariant.featured_media) {
      this.resetMediaToFirst();
      return;
    }
    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    // <media-gallery> is rendered before media-gallery.js (deferred) upgrades it, so
    // setActiveMedia is undefined in that window. Same failure as pickup-availability.
    mediaGalleries.forEach((mediaGallery) => {
      if (typeof mediaGallery.setActiveMedia !== "function") return;
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, false);
    });
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
    modalContent.style.marginTop = '20px';
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", {
        bubbles: true
      }));
    });
  }
  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1);
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option'), ];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(
        (variant) => variant.available && variant[`option${index}`] === previousOptionSelected).map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = ((window.variantStrings || {}).unavailable_with_option || "[value]").replace("[value]", input.getAttribute("value"));
      }
    });
  }
  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;
    // The element is rendered by pi-buy-buttons before pickup-availability.js (deferred)
    // has run, so between parse and upgrade it is a plain unknown element with no
    // fetchAvailability method. Calling it threw, and because this runs BEFORE the button
    // state is resolved in onVariantChange, the throw left Add to Bag stuck disabled.
    if (typeof pickUpAvailability.fetchAvailability !== "function") return;
    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }
  toggeleTextOpacity(opacity = "0") {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButtonText) return;
    addButtonText.style["opacity"] = opacity;
  }
  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;
    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }
  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`).then((response) => response.text()).then((responseText) => {
      // prevent unnecessary ui changes from abandoned selections
      if (this.currentVariant.id !== requestedVariantId) {
        // toggleAddButton() hid the label at opacity 0 and only this method restores it.
        // Returning here without restoring left the button permanently blank — which is
        // what happens when the shopper switches variants faster than the fetch resolves.
        this.toggeleTextOpacity("1");
        return;
      }
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const destination = document.getElementById(`price-${this.dataset.section}`);
      const source = html.getElementById(`price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`);
      const skuSource = html.getElementById(`Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`);
      const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
      const inventorySource = html.getElementById(`Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`);
      const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
      const volumePricingSource = html.getElementById(`Volume-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`);
      const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
      const pricePerItemSource = html.getElementById(`Price-Per-Item-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`);
      const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
      const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
      const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
      // In-button price (pi-buy-buttons) — refreshed alongside the main price block.
      const buttonPriceDestination = document.getElementById(`ButtonPrice-${this.dataset.section}`);
      const buttonPriceSource = html.getElementById(`ButtonPrice-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`);
      if (buttonPriceSource && buttonPriceDestination) buttonPriceDestination.innerHTML = buttonPriceSource.innerHTML;
      if (volumeNote) volumeNote.classList.remove("hidden");
      if (volumePricingDestination) volumePricingDestination.classList.remove("hidden");
      if (qtyRules) qtyRules.classList.remove("hidden");
      if (source && destination) destination.innerHTML = source.innerHTML;
      if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
      if (skuSource && skuDestination) {
        skuDestination.innerHTML = skuSource.innerHTML;
        skuDestination.classList.toggle("hidden", skuSource.classList.contains("hidden"));
      }
      if (volumePricingSource && volumePricingDestination) {
        volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
      }
      if (pricePerItemSource && pricePerItemDestination) {
        pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
        pricePerItemDestination.classList.toggle("hidden", pricePerItemSource.classList.contains("hidden"));
      }
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (price) price.classList.remove("hidden");
      if (inventoryDestination) inventoryDestination.classList.toggle("hidden", inventorySource.innerText === "");
      const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
      this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : !this.currentVariant.available, (window.variantStrings || {}).soldOut);
      this.toggeleTextOpacity("1");
      publish(PUB_SUB_EVENTS.variantChange, {
        data: {
          sectionId,
          html,
          variant: this.currentVariant,
        },
      });
    }).catch(() => {
      // A failed or slow section fetch must never leave the button blank and the block
      // collapsed. Restore the label and reveal the block regardless.
      this.toggeleTextOpacity("1");
      const block = document.querySelector('.pi-product-content-block');
      if (block) block.classList.remove('hide', 'initialhide');
    });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const addButtonPrice = productForm.querySelector('[name="add"] .inline-price');
    const buttonsWrapper = productForm.querySelector('.product-form__buttons');
    this.toggeleTextOpacity('0');
    if (!addButton) return;
    // Only surface the in-button price once a real variant is resolved.
    // inline-flex, not block — the compare-at/sale spacing is a flex gap.
    if (addButtonPrice) addButtonPrice.style["display"] = this.currentVariant ? "inline-flex" : "none";
    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text && addButtonText) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      if (addButtonText) addButtonText.textContent = (window.variantStrings || {}).addToCart || "Add to bag";
    }
    if (buttonsWrapper) buttonsWrapper.classList.add('has__variant');
    if (!modifyClass) return;
  }
  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    if (!button) return;
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = (window.variantStrings || {}).unavailable || "Unavailable";
    if (price) price.classList.add("hidden");
    if (inventory) inventory.classList.add("hidden");
    if (sku) sku.classList.add("hidden");
    if (pricePerItem) pricePerItem.classList.add("hidden");
    if (volumeNote) volumeNote.classList.add("hidden");
    if (volumeTable) volumeTable.classList.add("hidden");
    if (qtyRules) qtyRules.classList.add("hidden");
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  // Whether the selected variant qualifies for the complimentary box offer.
  //
  // Replaces the old `sku.indexOf('-COMBO') > -1` test. That was a substring match on a SKU
  // convention that the catalogue does not actually follow: the Yes Chef! singles use -DUO
  // suffixes, so their duo variants never showed the offer at all.
  //
  // Qualifying names come from the section setting rendered into data-variant-names, so
  // merchandising can change them in the theme editor. Comparison is case-insensitive,
  // whitespace-collapsed, and treats "&" and "and" as equivalent, so "Gel Polish & Lacquer"
  // and "Gel Polish and Lacquer" both match the same entry. Checks the full variant title
  // and each option value, so it works on single- and multi-option products alike.
  // Shows or hides the box. A hidden box is disabled too, so it is never submitted.
  setComplimentaryBox(box, on) {
    if (!box) return;
    box.classList.toggle('active', on);
    const checkbox = box.querySelector('input[type="checkbox"]');
    if (checkbox) checkbox.disabled = !on;
  }

  qualifiesForComplimentaryBox(variant, box) {
    if (!variant || !box) return false;

    if (!this._complimentaryNames) {
      this._complimentaryNames = (box.dataset.variantNames || '')
        .split(/[\r\n,]+/)
        .map((name) => this.normalizeVariantName(name))
        .filter(Boolean);
    }
    if (!this._complimentaryNames.length) return false;

    const candidates = [variant.title, variant.option1, variant.option2, variant.option3];
    if (Array.isArray(variant.options)) candidates.push(...variant.options);

    return candidates.some((candidate) => {
      const normalized = this.normalizeVariantName(candidate);
      return normalized && this._complimentaryNames.indexOf(normalized) > -1;
    });
  }

  normalizeVariantName(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, ' and ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  // Select the option value named by the section setting, or the first available variant if
  // the setting is blank. Returns true when a variant was resolved and the UI updated.
  applyPreselectedVariant() {
    const wanted = (this.dataset.preselect || '').trim().toLowerCase();
    const radios = Array.from(this.querySelectorAll('input[type="radio"]'));
    const selects = Array.from(this.querySelectorAll('select.select2'));
    let matched = false;

    if (wanted) {
      radios.forEach((radio) => {
        if ((radio.value || '').trim().toLowerCase() === wanted) {
          radio.checked = true;
          matched = true;
        }
      });
      selects.forEach((select) => {
        Array.from(select.options).forEach((opt) => {
          if ((opt.value || '').trim().toLowerCase() === wanted) {
            select.value = opt.value;
            matched = true;
          }
        });
      });
    }

    // Blank setting, or a value that matches nothing: fall back to the first option.
    if (!matched) {
      this.preselectSoleOption();
      const firstRadio = radios[0];
      if (firstRadio && !radios.some((r) => r.checked)) firstRadio.checked = true;
    }

    this.onVariantChange();
    return !!this.currentVariant;
  }

  // Clicking the already-selected option clears it and returns the page to its unselected
  // state — the lead image comes back and Add to Bag reverts to "Select a Variant".
  enableVariantDeselect() {
    this.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener('mousedown', () => {
        radio.dataset.wasChecked = radio.checked ? 'true' : 'false';
      });
      radio.addEventListener('click', () => {
        if (radio.dataset.wasChecked !== 'true') return;
        radio.checked = false;
        radio.dataset.wasChecked = 'false';
        this.resetVariantSelection();
      });
    });
  }

  resetVariantSelection() {
    this.currentVariant = undefined;
    this.resetMediaToFirst();
    this.onVariantChange();
  }

  // True when the shopper has nothing to actually choose: a single variant, or every
  // option exposing exactly one value. Forcing "Select a Variant" in that case is a dead
  // end — there is no second option to switch to, so the change event never fires and
  // Add to Cart can never become enabled.
  hasNoVariantChoice() {
    const variants = this.getVariantData();
    if (!variants || variants.length <= 1) return true;
    const selects = Array.from(this.querySelectorAll('select.select2'));
    if (selects.length && selects.every((sel) => sel.options.length <= 1)) return true;
    // picker_type "button" renders <variant-radios>, which has fieldsets of radios rather
    // than selects. Without this branch a single-option radio product never auto-selected.
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    if (
      fieldsets.length &&
      fieldsets.every((fs) => fs.querySelectorAll('input[type="radio"]').length <= 1)
    ) {
      return true;
    }
    return false;
  }

  // updateOptions() reads whichever option is currently selected. product-variant-options
  // no longer renders `checked`, so on load nothing is selected and updateOptions would
  // throw for radios. Select the sole option first so there is something to read.
  preselectSoleOption() {
    this.querySelectorAll('fieldset').forEach((fieldset) => {
      const radios = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
      if (radios.length && !radios.some((radio) => radio.checked)) {
        radios[0].checked = true;
      }
    });
    this.querySelectorAll('select.select2').forEach((select) => {
      if (select.selectedIndex < 0 && select.options.length) select.selectedIndex = 0;
    });
  }

  deselectVariantOnLoad() {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const variantInput = productForm.querySelector('input.product-variant-id');
    const addButton = productForm.querySelector('[name="add"]');
    if (!addButton) return;
    const addButtonText = addButton.querySelector('span');
    const addButtonPrice = addButton.querySelector('.inline-price');

    // Section setting: pre-select a variant on load (e.g. running a "Gel Only" promotion).
    // data-preselect is only present when the setting is enabled; an empty value means
    // "first available variant".
    if (this.dataset.preselect !== undefined && this.applyPreselectedVariant()) return;

    if (this.hasNoVariantChoice()) {
      this.preselectSoleOption();
      this.updateOptions();
      this.updateMasterId();
      if (this.currentVariant) {
        this.updateVariantInput();
        this.toggleVariantDescription();
        this.toggleAddButton(!this.currentVariant.available, (window.variantStrings || {}).soldOut, true);
        this.toggeleTextOpacity('1');
        const contentBlock = document.querySelector('.pi-product-content-block');
        if (contentBlock) contentBlock.classList.remove('initialhide');
        return;
      }
    }

    // The variant id is being cleared, so the button must not be submittable.
    if (variantInput) variantInput.value = '';
    addButton.setAttribute('disabled', 'disabled');
    if (addButtonText) addButtonText.textContent = 'Choose an option';
    if (addButtonPrice) addButtonPrice.style['display'] = 'none';
  }
}

customElements.define("variant-selects", VariantSelects);

/*
 * Suppress Swym's own injected PDP wishlist button.
 *
 * We render our own heart (snippets/pi-product-wishlist-button.liquid) overlaid on the
 * gallery. Swym, configured to "On product image", injects a second one in the same corner —
 * two hearts on Chrome. Deleting ours is not an option: Swym's button does not reliably
 * render on Safari, which is where this whole investigation started.
 *
 * Identified by exclusion rather than by class name, because Swym's markup is app-controlled
 * and has changed shape already. Anything that is a wishlist control, is on the product page,
 * is not ours, and is not part of a recommendation card, gets hidden.
 */
(function () {
  function sweep() {
    if (!document.body || document.body.className.indexOf('page-product') === -1) return;
    var candidates = document.querySelectorAll(
      '[data-swaction="addToWishlist"], .swym-add-to-wishlist, .swym-add-to-wishlist-view-product, #swym-atw-pdp-button, .swym-atw-btn-wrapper'
    );
    candidates.forEach(function (el) {
      if (el.closest('.product__media-wishlist')) return;                 // ours - keep
      if (el.closest('.card, .card-wrapper, .quick-add, .product-grid')) return; // cards - keep
      if (el.dataset && el.dataset.piHidden === '1') return;
      el.style.setProperty('display', 'none', 'important');
      if (el.dataset) el.dataset.piHidden = '1';
    });
  }

  function start() {
    sweep();
    // Swym injects roughly a second after its SDK loads, and can re-inject later.
    [300, 1000, 2000, 4000, 8000].forEach(function (t) { setTimeout(sweep, t); });
    if (window.MutationObserver) {
      new MutationObserver(sweep).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/*
 * Buy-button watchdog.
 *
 * The Add to Bag button has gone missing intermittently on Safari. Several causes have been
 * removed already (JS-gated visibility, a network-gated disable, invalid <div> nesting inside
 * the <button>, a CDN dependency that could throw). It is still a conversion-critical element
 * whose visibility depends on classes toggled by async code and by third-party apps (Swym
 * wraps it in .swym-atw-btn-wrapper roughly a second after its SDK loads).
 *
 * This does two things: it restores the button if anything collapses its container, and it
 * records what did it on window.__buyButtonWatchdog so the cause is visible rather than
 * inferred. Purely defensive — it never hides anything.
 */
(function () {
  if (!document.querySelector) return;
  var log = (window.__buyButtonWatchdog = window.__buyButtonWatchdog || []);

  // REPAIR MODE (the correct setting for a published theme).
  //
  // Every cause this was built for has since been fixed at the source: Swym moved off "Near
  // cart button" (dashboard, not theme), the invalid <div> nesting inside the <button> is
  // gone, the CDN scripts are local, and the custom-element upgrade races are guarded. The
  // watchdog is kept as a safety net in case a future app or edit reintroduces one of them.
  //
  // REPORT_ONLY = true makes it observe and log WITHOUT repairing. That is a diagnostic
  // mode for an unpublished copy only: on a live theme it means a broken Add to Bag button
  // stays broken. It shipped set to true once by mistake — leave this false unless you are
  // actively diagnosing on a preview, and set it back before publishing.
  //
  // Inspect the log in the browser console with: window.__buyButtonWatchdog
  var REPORT_ONLY = false;

  // ── Plain-language reporting ───────────────────────────────────────────────────────
  // Reading a diagnostic panel means remembering to append ?debug=1 to every URL, which on a
  // theme preview means &debug=1 instead, and it only reports the page you are on.
  //
  // This is the version a human can actually run: switch it on once per device with
  // ?buttonwatch=on, then use the site normally. Nothing appears unless something is actually
  // detected, at which point a red bar says what happened. Findings are kept in localStorage
  // so they survive navigation — ?buttonwatch=log shows everything collected so far, and
  // ?buttonwatch=off switches it back off and clears it.
  //
  // Opt-in per browser, so a customer never sees any of it even if this ships.
  var WATCH_KEY = 'piBuyButtonWatch', LOG_KEY = 'piBuyButtonWatchLog';

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function lsDel(k) { try { localStorage.removeItem(k); } catch (e) {} }

  var mode = null;
  try { mode = new URLSearchParams(location.search).get('buttonwatch'); } catch (e) {}
  if (mode === 'on') lsSet(WATCH_KEY, '1');
  if (mode === 'off') { lsDel(WATCH_KEY); lsDel(LOG_KEY); }
  var watching = lsGet(WATCH_KEY) === '1';

  function banner(text, colour) {
    function show() {
      if (!document.body) return;
      var bar = document.createElement('div');
      bar.setAttribute('style', [
        'position:fixed', 'top:0', 'left:0', 'right:0', 'z-index:2147483647',
        'background:' + colour, 'color:#fff', 'padding:14px 46px 14px 16px',
        'font:600 14px/1.5 -apple-system,BlinkMacSystemFont,Segoe UI,sans-serif',
        'white-space:pre-wrap', 'box-shadow:0 2px 8px rgba(0,0,0,.3)'
      ].join(';'));
      bar.textContent = text;
      var x = document.createElement('button');
      x.textContent = '\u00d7';
      x.setAttribute('style', 'position:absolute;top:6px;right:10px;background:none;border:0;color:#fff;font-size:26px;line-height:1;cursor:pointer');
      x.onclick = function () { bar.remove(); };
      bar.appendChild(x);
      document.body.appendChild(bar);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', show);
    else show();
  }

  function report(entry) {
    if (!watching) return;
    var history = [];
    try { history = JSON.parse(lsGet(LOG_KEY) || '[]'); } catch (e) {}
    history.push({ when: new Date().toISOString(), where: location.pathname, cause: entry.cause });
    lsSet(LOG_KEY, JSON.stringify(history.slice(-25)));
    banner('BUTTON ISSUE DETECTED \u2014 please screenshot this and send it over.\n\n' +
           entry.cause + '\n\nPage: ' + location.pathname, '#c0141f');
  }

  if (mode === 'on') banner('Button watch is ON for this browser. Use the site normally \u2014 nothing else will appear unless a problem is found.', '#1a7f37');
  if (mode === 'off') banner('Button watch is OFF and the record has been cleared.', '#444');
  if (mode === 'log') {
    var saved = [];
    try { saved = JSON.parse(lsGet(LOG_KEY) || '[]'); } catch (e) {}
    banner(saved.length
      ? 'Button watch found ' + saved.length + ' issue(s). Screenshot this:\n\n' +
        saved.map(function (r) { return r.when + '  ' + r.where + '\n  ' + r.cause; }).join('\n')
      : 'Button watch has recorded nothing. That is the result we want \u2014 the button has not misbehaved once.',
      saved.length ? '#c0141f' : '#1a7f37');
  }

  function note(entry) {
    entry.at = Date.now();
    if (REPORT_ONLY) entry.repaired = false;
    log.push(entry);
    if (!entry.baseline) report(entry);
  }

  // ── Confirm before reporting ───────────────────────────────────────────────────────
  // A collapsed content block is NORMAL for up to 1.5s. onVariantChange() adds .hide to run
  // the close animation, clears it on a 500ms timer, and keeps a 1500ms failsafe behind that.
  // This watchdog samples at 300/1000/2000/4000/8000ms AND on every mutation, so it kept
  // catching that deliberate state — two false alarms in the first session of real use, on
  // pages where the button was plainly fine.
  //
  // Nothing is reported on first sight any more. The condition is re-tested once the failsafe
  // has had time to fire, and only a state that is STILL broken is worth a red bar. The probe
  // returns a fresh cause string (or nothing), so what gets logged is the state at confirm
  // time rather than the transient one that triggered the check.
  var CONFIRM_MS = 2500;
  var pending = {};

  function confirmThenReport(key, probe) {
    if (pending[key]) return;
    pending[key] = true;
    setTimeout(function () {
      pending[key] = false;
      var cause = probe();
      if (cause) note({ cause: cause, confirmedAfterMs: CONFIRM_MS });
    }, CONFIRM_MS);
  }

  // Captured on first sight so the button can be put back if something detaches it.
  var keptButton = null, keptParent = null;

  function ensureVisible() {
    var host = document.querySelector('product-info .product-form__buttons');
    var btn = host ? host.querySelector('[name="add"]') : null;

    if (btn) {
      keptButton = btn;
      keptParent = btn.parentElement;
    } else if (keptButton && keptParent) {
      // The button was removed from the document. Swym's "position wishlist button next to
      // add to cart" feature re-parents this element about a second after its SDK loads, and
      // that is when it has been going missing. Put it back where it belongs.
      confirmThenReport('detached', function () {
        var h = document.querySelector('product-info .product-form__buttons');
        if (h && h.querySelector('[name="add"]')) return null;
        return 'button detached from DOM';
      });
      if (!REPORT_ONLY) {
        if (document.contains(keptParent)) {
          keptParent.appendChild(keptButton);
        } else if (host) {
          host.appendChild(keptButton);
        }
      }
      btn = keptButton;
    }
    if (!btn) return;

    var block = btn.closest('.pi-product-content-block');
    if (block && (block.classList.contains('hide') || block.classList.contains('initialhide'))) {
      confirmThenReport('collapsed', (function (blk) {
        return function () {
          if (!document.contains(blk)) return null;
          if (!blk.classList.contains('hide') && !blk.classList.contains('initialhide')) return null;
          return 'content block still collapsed after ' + CONFIRM_MS + 'ms: ' + blk.className;
        };
      })(block));
      if (!REPORT_ONLY) block.classList.remove('hide', 'initialhide');
    }

    // Walk up from the button, but STOP at product-info. Without this bound the walk ran on
    // into recommendation-card markup (div.quick-add / div.card__content) and "un-hid" cards
    // that are supposed to be hidden — the watchdog was causing damage of its own.
    var node = btn.parentElement, depth = 0;
    while (node && node !== document.body && depth++ < 6) {
      if (node.tagName === 'PRODUCT-INFO') break;
      if (node.closest && node.closest('.quick-add, .card, .card-wrapper')) break;
      // The content block is in this chain and is checked above on its own terms. Without
      // this the same collapse is reported twice — two red bars for one problem.
      if (node === block) { node = node.parentElement; continue; }
      var cs = getComputedStyle(node);
      if (cs.display === 'none' || cs.visibility === 'hidden' || cs.maxHeight === '0px') {
        confirmThenReport('ancestor:' + node.tagName + (node.className || ''), (function (n) {
          return function () {
            if (!document.contains(n)) return null;
            var c = getComputedStyle(n);
            if (c.display !== 'none' && c.visibility !== 'hidden' && c.maxHeight !== '0px') return null;
            return 'ancestor still hidden after ' + CONFIRM_MS + 'ms: ' +
                   n.tagName.toLowerCase() + '.' + (n.className || '') +
                   ' (display:' + c.display + ' visibility:' + c.visibility + ' maxHeight:' + c.maxHeight + ')';
          };
        })(node));
        if (!REPORT_ONLY) {
          if (cs.maxHeight === '0px') node.style.maxHeight = 'none';
          if (cs.display === 'none') node.style.display = '';
          if (cs.visibility === 'hidden') node.style.visibility = 'visible';
        }
      }
      node = node.parentElement;
    }
  }

  // Capture immediately. global.js is deferred, so the document is already parsed and the
  // button exists right now — whereas Swym can detach it before DOMContentLoaded fires,
  // which would leave the watchdog with no reference to restore from.
  (function captureNow() {
    var host = document.querySelector('product-info .product-form__buttons');
    var btn = host ? host.querySelector('[name="add"]') : null;
    if (btn) {
      keptButton = btn;
      keptParent = btn.parentElement;
      note({ cause: 'captured button reference at script execution', baseline: true });
    }
  })();

  function start() {
    ensureVisible();
    // Third-party scripts (Swym in particular) rearrange this area well after load.
    [300, 1000, 2000, 4000, 8000].forEach(function (t) { setTimeout(ensureVisible, t); });
    if (window.MutationObserver) {
      var recheck = new MutationObserver(function () { ensureVisible(); });
      var host = document.querySelector('product-info .product-form__buttons');
      if (host) {
        recheck.observe(host, { attributes: true, attributeFilter: ['class', 'style'], childList: true, subtree: true });
      }
      // The content block is an ANCESTOR of that host, so class changes on it — which is
      // exactly what collapses the button — do not surface in the observer above. Without
      // this, a block left collapsed after the 8s startup polling has finished is never
      // noticed at all.
      var blockHost = document.querySelector('product-info .pi-product-content-block');
      if (blockHost) {
        recheck.observe(blockHost, { attributes: true, attributeFilter: ['class', 'style'] });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();


class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      // product-variant-options no longer renders `checked`, so on first load no radio is
      // selected and .find() returns undefined. Reading .value off that threw a TypeError
      // and took down whatever called updateOptions().
      const checked = Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      );
      return checked ? checked.value : null;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

// JavaScript

// ADA: the labels were click-only <div>s, and every inactive one was
// aria-hidden, so a keyboard user could not switch tabs and a screen reader
// heard only the current one. They are now an ARIA tablist: role=tab with
// aria-selected, a roving tabindex, and arrow / Home / End / Enter / Space.
// Which label is current lives in data-active, which is what the CSS styles.
class PiTabPanel extends HTMLElement {
  constructor() {
    super();

    // Get tab labels and panels
    this.tabs = Array.from(this.querySelectorAll(".pi-tab-label"));
    this.panels = this.querySelectorAll(".pi-tab-panel");

    PiTabPanel.count = (PiTabPanel.count || 0) + 1;
    const uid = this.id || `pi-tabs-${PiTabPanel.count}`;
    const list = this.querySelector(".pi-tab-labels-wrapper");
    if (list) list.setAttribute("role", "tablist");

    this.tabs.forEach((tab, i) => {
      const panel = this.panels[i];
      if (!tab.id) tab.id = `${uid}-tab-${i}`;
      tab.setAttribute("role", "tab");
      tab.removeAttribute("aria-hidden");
      if (panel) {
        if (!panel.id) panel.id = `${uid}-panel-${i}`;
        tab.setAttribute("aria-controls", panel.id);
        panel.setAttribute("role", "tabpanel");
        panel.setAttribute("aria-labelledby", tab.id);
      }
      tab.addEventListener("click", () => this.showPanel(tab));
      tab.addEventListener("keydown", (e) => this.onKeydown(e, i));
    });

    this.syncTabs(this.tabs.find((t) => t.dataset.active === "true") || this.tabs[0]);
  }

  onKeydown(event, index) {
    const last = this.tabs.length - 1;
    const target = {
      ArrowRight: index === last ? 0 : index + 1,
      ArrowLeft: index === 0 ? last : index - 1,
      Home: 0,
      End: last,
    }[event.key];
    if (target !== undefined) {
      event.preventDefault();
      this.showPanel(this.tabs[target]);
      this.tabs[target].focus();
    } else if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.showPanel(this.tabs[index]);
    }
  }

  syncTabs(activeTab) {
    this.tabs.forEach((tab) => {
      const on = tab === activeTab;
      tab.dataset.active = on ? "true" : "false";
      tab.setAttribute("aria-selected", on ? "true" : "false");
      tab.setAttribute("tabindex", on ? "0" : "-1");
    });
  }

  showPanel(activeTab) {
    // Hide all panels
    this.panels.forEach((panel) => {
      panel.setAttribute("aria-hidden", true);
      panel.removeAttribute("open");
    });

    // Show active panel
    let activePanel = this.panels[Array.from(this.tabs).indexOf(activeTab)];
    activePanel.setAttribute("aria-hidden", false);
    activePanel.setAttribute("open", "");

    // Update tabs
    this.syncTabs(activeTab);
  }
}

customElements.define("pi-tab-panel", PiTabPanel);

class PiTabPanelToggle extends HTMLElement {
  constructor() {
    super();
    // Get tab labels and panels
    this.tabs = this.querySelectorAll(".pi-tab-label");
    this.panels = this.querySelectorAll(".pi-tab-panel");
    this.activePanel = null;

    // ADA: each label is a disclosure button (Filter by / Sort by) — focusable,
    // operable with Enter and Space, and reporting aria-expanded. They were
    // click-only, aria-hidden <div>s. data-active carries the styling state.
    PiTabPanelToggle.count = (PiTabPanelToggle.count || 0) + 1;
    this.tabs.forEach((tab, index) => {
      const panel = this.panels[index];
      tab.setAttribute("role", "button");
      tab.setAttribute("tabindex", "0");
      tab.removeAttribute("aria-hidden");
      if (panel) {
        if (!panel.id) panel.id = `pi-tab-toggle-${PiTabPanelToggle.count}-panel-${index}`;
        tab.setAttribute("aria-controls", panel.id);
      }
      tab.addEventListener("click", () => {
        this.togglePanel(index);
      });
      tab.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          this.togglePanel(index);
        }
      });
    });

    // Set aria-expanded initially
    this.syncTabs(-1);
    this.updateAriaExpanded();

    document.addEventListener("close:pi-tab-panel", () => {
      this.activePanel = null;
      this.panels.forEach((panel) => {
        panel.setAttribute("aria-hidden", true);
        panel.removeAttribute("open");
      });
      this.syncTabs(-1);
      this.updateAriaExpanded();
    });
  }

  syncTabs(activeIndex) {
    this.tabs.forEach((tab, i) => {
      const on = i === activeIndex;
      tab.dataset.active = on ? "true" : "false";
      tab.setAttribute("aria-expanded", on && this.panels[i] === this.activePanel ? "true" : "false");
    });
  }

  togglePanel(index) {
    // Get the panel to toggle
    const panelToToggle = this.panels[index];

    // If the panel is already open, close it
    if (panelToToggle === this.activePanel) {
      panelToToggle.setAttribute("aria-hidden", true);
      panelToToggle.removeAttribute("open");
      this.activePanel = null;
    } else {
      // Close the previously open panel (if any)
      if (this.activePanel) {
        this.activePanel.setAttribute("aria-hidden", true);
        this.activePanel.removeAttribute("open");
      }

      // Open the clicked panel
      panelToToggle.setAttribute("open", "");
      panelToToggle.setAttribute("aria-hidden", false);
      this.activePanel = panelToToggle;
    }

    // Update tabs
    this.syncTabs(index);
    // Update aria-expanded
    this.updateAriaExpanded();
  }

  updateAriaExpanded() {
    const isAnyPanelOpen = Array.from(this.panels).some((panel) =>
      panel.hasAttribute("open")
    );
    this.setAttribute("aria-expanded", isAnyPanelOpen.toString());
  }
}

customElements.define("pi-tab-panel-toggle", PiTabPanelToggle);

class PISELECT extends HTMLElement {
  constructor() {
    super();
    this.masterSelect = this.querySelector("select");
    this.piSelectedValue = this.querySelector("[pi-select-selected-value]");
    this.piOptions = this.querySelectorAll("[pi-select-item]");
    this.piOptions.forEach((option) => {
      option.addEventListener("click", this.onOptionClick.bind(this));
      // ADA: options carry role="option" tabindex="0" but only had a click
      // listener, leaving the sort control reachable by keyboard yet not
      // operable. Enter/Space now activate the focused option.
      option.addEventListener("keydown", this.onOptionKeydown.bind(this));
    });
    this.details = this.querySelector("details");
  }

  onOptionKeydown(event) {
    if (event.key !== "Enter" && event.key !== " " && event.key !== "Spacebar")
      return;
    event.preventDefault();
    this.onOptionClick(event);
  }

  onOptionClick(event) {
    event.preventDefault();
    const option = event.currentTarget;
    const value = option.getAttribute("data-value");
    this.piOptions.forEach((o) => {
      if (o.hasAttribute("role"))
        o.setAttribute("aria-selected", o === option ? "true" : "false");
    });
    this.piSelectedValue.innerHTML = option.innerHTML;
    this.masterSelect.value = value;
    this.masterSelect.dispatchEvent(
      new CustomEvent("input", { bubbles: true })
    );
    if (this.details && !this.hasAttribute("change-outer-selector")) {
      this.details.removeAttribute("open");
    }
    // Extera event for changing outer selector
    if (this.hasAttribute("change-outer-selector")) {
      const outerSelected = document.querySelector(
        this.getAttribute("change-outer-selector")
      );
      if (outerSelected) {
        outerSelected.innerHTML = option.innerHTML;
        document.dispatchEvent(new CustomEvent("close:pi-tab-panel"));
      }
    }
  } // onOptionClick
}

customElements.define("pi-select", PISELECT);

// Updating Cards Yotpo reviews count
document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(() => {
    document.querySelectorAll('.card-yotpo-reviews .yotpo-bottomline a.text-m').forEach(el => {
      const text = el.textContent.trim();
      const match = text.match(/^(\d+)\s+Review[s]?$/i);
      if (match) {
        el.textContent = `(${match[1]})`;
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

/*
 * Product description: "Read more" / "Read less".
 *
 * This lived as an inline <script> at the bottom of sections/main-product.liquid, positioned
 * AFTER </section>. quick-add.js lifts `section[id^="MainProduct-"]` and injects only its
 * innerHTML, so the modal never received the script and the toggle was dead in there — the
 * link rendered and did nothing.
 *
 * Rewritten with delegation from `document` so it needs no binding at all: markup injected
 * later, by quick-add or anything else, is handled by the same listeners. Only the parts that
 * genuinely need to touch the DOM up front — inserting the "Read less" link, and measuring
 * whether a clamped description actually overflows — run in piInitDescriptions(), which
 * quick-add.js calls after it injects.
 */
(function () {
  function parts(container) {
    return {
      shortText: container.querySelector('.short-text'),
      fullText: container.querySelector('.full-text'),
    };
  }

  function setExpanded(container, expanded) {
    var p = parts(container);
    if (!p.shortText || !p.fullText) return;
    p.shortText.style.display = expanded ? 'none' : 'inline';
    p.fullText.style.display = expanded ? 'inline' : 'none';
    var readLess = p.fullText.querySelector('.read-less');
    if (readLess) readLess.style.display = expanded ? 'inline' : 'none';
    container.dataset.expanded = expanded ? 'true' : 'false';
  }

  function isExpanded(container) {
    return container.dataset.expanded === 'true';
  }

  // Decoration: the bits delegation cannot do for us.
  window.piInitDescriptions = function () {
    document.querySelectorAll('.product__description').forEach(function (container) {
      // (a) teaser + "Read more" produced by truncatewords in the Liquid
      var p = parts(container);
      var readMore = container.querySelector('a.read-more');
      if (readMore && p.shortText && p.fullText && container.dataset.readMoreBound !== 'true') {
        container.dataset.readMoreBound = 'true';
        var readLess = document.createElement('a');
        readLess.href = '#';
        readLess.className = 'read-less';
        readLess.innerText = 'Read less';
        readLess.style.display = 'none';
        readLess.setAttribute('aria-expanded', 'true');
        p.fullText.appendChild(readLess);
        readMore.setAttribute('aria-expanded', 'false');
        // Clicking anywhere in the collapsed description still expands it, but the two links
        // stay the real controls. The container must NOT carry role="button" + tabindex: a
        // button wrapping its own focusable link is nested-interactive (WCAG 4.1.2) and the
        // a11y gate rejects it. aria-expanded cannot live on the container either — a
        // role-less div may not take it — so each link carries its own, accurate as a
        // constant because each is visible in exactly one state.
        container.classList.add('is-expandable');
        container.dataset.expanded = 'false';
      }

      // (b) inside the quick-add modal a product with no tabs renders its description in
      // full, which buries the variant picker and the buy button. Clamp it to a teaser.
      if (!container.closest('.quick-add-modal')) return;
      if (container.querySelector('.short-text')) return;
      if (container.dataset.clampBound === 'true') return;
      container.dataset.clampBound = 'true';

      container.classList.add('pi-desc-clamp');
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'pi-desc-toggle';
      toggle.textContent = 'Read more';
      toggle.setAttribute('aria-expanded', 'false');
      container.insertAdjacentElement('afterend', toggle);

      // Measure after layout; a description short enough to fit needs no control at all.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (container.scrollHeight <= container.clientHeight + 1) {
            container.classList.remove('pi-desc-clamp');
            toggle.remove();
          }
        });
      });
    });
  };

  document.addEventListener('click', function (e) {
    // clamped description (quick-add): its own button, sitting after the container
    var clampToggle = e.target.closest('.pi-desc-toggle');
    if (clampToggle) {
      var clamped = clampToggle.previousElementSibling;
      if (!clamped) return;
      var nowClamped = clamped.classList.toggle('pi-desc-clamp');
      clampToggle.textContent = nowClamped ? 'Read more' : 'Read less';
      clampToggle.setAttribute('aria-expanded', nowClamped ? 'false' : 'true');
      return;
    }

    var readMore = e.target.closest('a.read-more');
    if (readMore) {
      var c = readMore.closest('.product__description');
      if (!c) return;
      e.preventDefault();
      setExpanded(c, true);
      return;
    }

    var readLess = e.target.closest('a.read-less');
    if (readLess) {
      var c2 = readLess.closest('.product__description');
      if (!c2) return;
      e.preventDefault();
      setExpanded(c2, false);
      return;
    }

    // anywhere in the collapsed teaser, but let real links do their own thing
    var container = e.target.closest('.product__description.is-expandable');
    if (!container || e.target.closest('a')) return;
    if (isExpanded(container)) return;
    setExpanded(container, true);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.piInitDescriptions);
  } else {
    window.piInitDescriptions();
  }
})();

// ADA (WCAG 2.4.11 Focus Not Obscured): the header section is position:sticky,
// so tabbing down the page scrolled each focused element up underneath it.
// scroll-padding-top in base.css reads this offset, and it follows the
// header's real height across breakpoints and the announcement bar.
(() => {
  const header = document.querySelector(".section-header");
  if (!header) return;
  const setOffset = () => {
    const sticky = ["sticky", "fixed"].includes(getComputedStyle(header).position);
    const offset = sticky ? Math.ceil(header.getBoundingClientRect().height) + 8 : 0;
    document.documentElement.style.setProperty("--a11y-sticky-offset", `${offset}px`);
  };
  setOffset();
  if ("ResizeObserver" in window) new ResizeObserver(setOffset).observe(header);
  window.addEventListener("resize", setOffset);
})();
